export const allocation = 'al_cell_writing'

export const CONTROL = '2018-10-08--main'



// WEBPACK FOOTER //
// ./src/state/experiment/index.ts